import { useCallback, useEffect, useRef } from 'react';

interface useIntervalInputs {
	intervalTime?: number;
	callback: () => void;
}

export function useInterval({ intervalTime = 0, callback }: useIntervalInputs) {
	const timerRef = useRef<number | undefined>();
	const action = useCallback(callback, [callback]);

	const start = () => {
		timerRef.current = window.setInterval(action, intervalTime);
	};

	const stop = () => {
		clearInterval(timerRef.current);
		timerRef.current = undefined;
	};
	const reset = () => {
		stop();
		start();
	};

	useEffect(() => {
		return () => {
			stop();
		};
	}, [intervalTime]);
	return { start, reset, stop };
}
